import { useQuery } from "@tanstack/react-query";

import { useState } from 'react'
import axios from "../apis/axios";
import { generateURL, getToken } from "../utilities";

function useRead({ url, initialData, method, onSuccess = () => { }, onError = () => { }, enabled, keepPreviousData = false }) {
  const [paramsObject, setGetListParams] = useState(initialData)
  const data = useQuery(
    [url, paramsObject],
    () => getUsers(paramsObject),
    {
      keepPreviousData,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: enabled === null || enabled === undefined ? true : enabled,
      onSuccess: (data) => {
        onSuccess(data)
      },
      onError: (err) => {
        onError(err)
      }
    }
  )
  const getUsers = async (paramsObject) => {
    let fd = new FormData()
    for (var key in paramsObject) {
      fd.append(key, paramsObject[key]);
    }
    const response = await axios({
      method: method ? method : "POST",
      data: fd,
      url: `/${url}${paramsObject ? generateURL(paramsObject) : ''}`,
      headers: { Authorization: getToken() ? `Bearer ${getToken()}` : '', }
    })
    return response.data
  }
  return { paramsObject, setGetListParams, data }

}

export default useRead